// Intent: [Branding] [Trust] [SEO/GEO]
import React from "react";
import { AUSTEN_EMAIL, PORTAL_LOGIN_URL, SITE_NAVIGATION } from "../../config";
import { BrandLogo } from "../shared/BrandLogo";
const moreLinks = [{
  label: "Video Guides",
  href: "/guides/"
}, {
  label: "About",
  href: "/about/"
}, {
  label: "FAQ",
  href: "/faq/"
}];
function Footer() {
  return <footer className="bg-pfpc-navy pb-6 pt-9 text-pfpc-offwhite" data-id="element-57" data-mp="5msvjqzfs0z7">
      <div className="container-shell" data-id="element-58" data-mp="p1571efwmx4">
        <div className="grid gap-7 border-b border-pfpc-offwhite/15 pb-7 md:grid-cols-[1.2fr_1fr_1fr] md:gap-8" data-id="element-59" data-mp="q2g95vgh9eu">
          <div data-id="element-60" data-mp="3n3kb09pcmtrz">
            <BrandLogo size="footer" className="ring-4 ring-pfpc-offwhite" data-id="element-61" data-mp="3n32fxgefalln" />
            <p className="mt-4 max-w-sm text-[14px] leading-6 text-pfpc-offwhite/70" data-id="element-62" data-mp="3j1z18x842vm0">Custom flat pack cabinetry designed online for Perth trade, DIY and project customers.</p>
            <a href={`mailto:${AUSTEN_EMAIL}`} className="mt-3 inline-block break-all text-[14px] font-bold text-pfpc-offwhite underline decoration-pfpc-orange underline-offset-4 hover:text-pfpc-orange" data-id="element-63" data-mp="3e2480n0v5txs">
              {AUSTEN_EMAIL}
            </a>
            {/* Phone, address, ABN and opening hours intentionally omitted until verified. */}
          </div>

          <div data-id="element-64" data-mp="2bd7vylw587e3">
            <h2 className="section-label mb-4 text-pfpc-orange" data-id="element-65" data-mp="2bdpvpsi0l3qr">Explore</h2>
            <ul className="space-y-2.5" data-id="element-66" data-mp="2gaq5oehziqn5">
              {[...SITE_NAVIGATION, ...moreLinks].map(item => <li key={item.href} data-id="element-67" data-mp="3425cokkphw4q"><a href={item.href} className="text-[14px] text-pfpc-offwhite/72 hover:text-pfpc-offwhite hover:underline" data-id="element-68" data-mp="341lqgro0wlkw">{item.label}</a></li>)}
            </ul>
          </div>

          <div data-id="element-69" data-mp="2u24oak7zcpto">
            <h2 className="section-label mb-4 text-pfpc-orange" data-id="element-70" data-mp="2u2o866h6xoac">Your account</h2>
            <ul className="space-y-2.5" data-id="element-71" data-mp="2z0pncgbhx3gj">
              <li data-id="element-72" data-mp="1inr3xpcfqsie"><a href="/register/trade/" className="text-[14px] font-bold text-pfpc-orange hover:underline" data-id="element-73" data-mp="1inr5hts330ki">Trades</a></li>
              <li data-id="element-74" data-mp="1nndka7nk8ovf"><a href="/register/diy/" className="text-[14px] text-pfpc-offwhite/72 hover:text-pfpc-offwhite hover:underline" data-id="element-75" data-mp="1nn41b40xnhz8">Do It Yourself - Easy</a></li>
              <li data-id="element-76" data-mp="13mu4mf2pbl7u"><a href={PORTAL_LOGIN_URL} className="text-[14px] text-pfpc-offwhite/72 hover:text-pfpc-offwhite hover:underline" data-id="element-77" data-mp="13mkbiimd0xxx">Log in</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-5 text-[13px] leading-5 text-pfpc-offwhite/60" data-id="element-78" data-mp="uqbbp2ugzxb9">
          <p data-id="element-79" data-mp="psjgnzyj3v2u">© {new Date().getFullYear()} Perth Flat Pack Cabinets. All rights reserved.</p>
          {/* Add approved privacy, terms, returns, delivery and accessibility links before launch. */}
        </div>
      </div>
    </footer>;
}
export { Footer };